/* global jQuery */

import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const handlerProps = [
  'handleShow',
  'handleShown',
  'handleHide',
  'handleHidden'
];

const bsModalEvents = {
  handleShow: 'show.bs.modal',
  handleShown: 'shown.bs.modal',
  handleHide: 'hide.bs.modal',
  handleHidden: 'hidden.bs.modal'
};

export default {
  propTypes: {
    handleShow: PropTypes.func,
    handleShown: PropTypes.func,
    handleHide: PropTypes.func,
    handleHidden: PropTypes.func,
    backdrop: PropTypes.bool,
    keyboard: PropTypes.bool,
    show: PropTypes.bool,
    remote: PropTypes.string
  },

  getDefaultProps() {
    return {
      backdrop: true,
      keyboard: true,
      show: true,
      remote: ''
    };
  },

  componentDidMount() {
    const $modal = jQuery(ReactDOM.findDOMNode(this)) // eslint-disable-line react/no-find-dom-node
      .modal({
        backdrop: this.props.backdrop,
        keyboard: this.props.keyboard,
        show: this.props.show,
        remote: this.props.remote
      });

    // Hack for how browsers+react deal with autofocus
    $modal.on('shown.bs.modal', () => this.autofocus());

    handlerProps.forEach((prop) => {
      if (this[prop]) {
        $modal.on(bsModalEvents[prop], this[prop]);
      }
      if (this.props[prop]) {
        $modal.on(bsModalEvents[prop], this.props[prop]);
      }
    });
  },

  componentWillUnmount() {
    const $modal = jQuery(ReactDOM.findDOMNode(this)); // eslint-disable-line react/no-find-dom-node

    handlerProps.forEach((prop) => {
      if (this[prop]) {
        $modal.off(bsModalEvents[prop], this[prop]);
      }
      if (this.props[prop]) {
        $modal.off(bsModalEvents[prop], this.props[prop]);
      }
    });
  },

  hide() {
    jQuery(ReactDOM.findDOMNode(this)) // eslint-disable-line react/no-find-dom-node
      .modal('hide');
  },

  show() {
    jQuery(ReactDOM.findDOMNode(this)) // eslint-disable-line react/no-find-dom-node
      .modal('show');

    jQuery('[data-toggle=tooltip]')
      .tooltip('hide');
  },

  toggle() {
    jQuery(ReactDOM.findDOMNode(this)) // eslint-disable-line react/no-find-dom-node
      .modal('toggle');
  },

  autofocus() {
    jQuery(ReactDOM.findDOMNode(this)) // eslint-disable-line react/no-find-dom-node
      .find(':input[data-autofocus]')
      .trigger("focus")
      .trigger("select");
  }
};
